import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // Supplemental roles for school staff.
    { value: 'staff:principal', label: 'Principal' },
    { value: 'staff:principalsDelegate', label: `Principal's Delegate` },
    {
      value: 'staff:processEnrolmentApplications',
      label: 'Process Enrolment Applications',
    },
    { value: 'staff:approveRollReturns', label: 'Approve Roll Returns' },
    { value: 'staff:pinPosts', label: 'Can Pin Posts' },
    { value: 'staff:approveEvents', label: 'Approve Events' },
  ],
});
